import { emailConfigurationsFilterOptions } from '../../constants/app.constants';
import { emailConfigurationActionTypes as ACTION } from '../actionTypes';

const initialState = {
  loading: false,
  hostNames: {
    data: {},
    message: '',
  },
  newEmailConfig: {
    data: {},
    message: '',
  },
  checkConnection: {
    data: {},
    message: '',
  },
  getAllEmailConfig: {
    data: {},
    message: '',
  },
  emailConfigDeleteData: {
    data: {},
    message: '',
  },
  filter: {
    [emailConfigurationsFilterOptions.Company]: [],
    [emailConfigurationsFilterOptions.Status]: [],
  },
  error: '',
};

const emailConfigurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.FETCH_HOST_NAMES_SUCCESS:
      return {
        ...state,
        hostNames: {
          ...state.hostNames,
          data: action.payload.data.payload,
        },
      };
    case ACTION.FETCH_HOST_NAMES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ACTION.NEWEMAILCONFIG_START_FETCH:
      return {
        ...state,
        loading: true,
        error: '',
        newEmailConfig: {
          message: '',
        },
      };
    case ACTION.NEWEMAILCONFIG_SUCCESS:
      let { message } = action.payload;
      return {
        ...state,
        loading: false,
        error: '',
        newEmailConfig: {
          message: message,
        },
      };
    case ACTION.NEWEMAILCONFIG_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        newEmailConfig: {
          message: '',
        },
      };
    case ACTION.CHECKCONNECTION_START_FETCH:
      return {
        ...state,
        loading: true,
        error: '',
        checkConnection: {
          message: '',
        },
      };
    case ACTION.CHECKCONNECTION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: '',
        checkConnection: {
          data: action.payload.payload,
          message: action.payload.message,
        },
      };
    }
    case ACTION.CHECKCONNECTION_FAILURE: {
      let { message, payload } = action.payload;
      return {
        ...state,
        loading: false,
        error: action.payload,
        checkConnection: {
          message: message,
        },
      };
    }

    case ACTION.EMAILCONFIG_START_FETCH:
      return {
        ...state,
        loading: true,
        error: '',
        getAllEmailConfig: {
          message: '',
        },
      };
    case ACTION.FETCH_EMAILCONFIG_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        getAllEmailConfig: {
          ...state.getAllEmailConfig,
          data: action.payload,
          message: '',
        },
        error: '',
      };
    case ACTION.FETCH_EMAILCONFIG_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        getAllEmailConfig: {
          data: {},
          message: action.payload,
        },
        error: '',
      };
    case ACTION.EMAILCONFIG_SET_ERROR:
      return { ...state, loading: false, error: action.payload };
    case ACTION.FETCH_EMAILCONFIG_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ACTION.EMAILCONFIG_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        emailConfigDeleteData: {
          message: action.payload.message,
        },
        error: '',
      };
    case ACTION.EMAILCONFIG_DELETE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case ACTION.REMOVE_EMAILCONFIG_DELETE_DATA:
      return {
        ...state,
        loading: false,
        emailConfigDeleteData: {
          message: '',
          data: null,
        },
        error: '',
      };
    case ACTION.CONFIG_FILTER_SUCCESS:
      const { key, values } = action.payload;
      return {
        ...state,
        loading: false,
        filter: {
          ...state.filter,
          [key]: [...values],
        },
      };
    case ACTION.CONFIG_FILTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default emailConfigurationReducer;
